import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { ModulePullRequestsTableRunCellProps } from "../types";

const ModulePullRequestsTableRunTitleCell = ({
  item: { pullRequest, run },
  moduleId,
  ...cellProps
}: ModulePullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={`/module/${moduleId}/run/${run.id}`}
        routerOptions={{ state: { prUrl: pullRequest.url, prTitle: pullRequest.title } }}
      >
        {run.expectFailure ? `${run.title} (should fail)` : run.title}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunTitleCell;
